var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEnUSreact = function SvgEnUSreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M24 6H1.5v1.5H24zM24 3H3v1.5h21zM24 9H3v1.5h21zM24 12H0v1.5h24zM24 15H0v1.5h24zM24 18H0v1.5h24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M24 7.5H0V9h24zM24 4.5H0V6h24zM0 10.5V12h10.5v-1.5zM24 13.5H0V15h24zM24 16.5H0V18h24zM24 19.5H0V21h24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M24 10.5H0V12h24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479B",
    d: "M13.5 12H0V3h13.5v9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3H1.5v1.5H3zM6 3H4.5v1.5H6zM9 3H7.5v1.5H9zM12 3h-1.5v1.5H12zM12 6h-1.5v1.5H12zM9 6H7.5v1.5H9zM6 6H4.5v1.5H6zM3 6H1.5v1.5H3zM3 9H1.5v1.5H3zM6 9H4.5v1.5H6zM9 9H7.5v1.5H9zM12 9h-1.5v1.5H12z"
  })));
};
export default SvgEnUSreact;